import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";

import { getTodayBreakStatusQueryOptions } from "@/config/queries/emp-query-options";
import { BreakList } from "@/components/break/break-list";
import { formatDuration } from "@/components/break/format";
import { formatTimeToIST } from "@/utils/timezone";

/** Live preview shown above the check-out form. */
export const TodaySoFar = () => {
  const key = Cookies.get("key") as string;
  const { data } = useQuery(getTodayBreakStatusQueryOptions(key));

  if (!data) return null;

  return (
    <div
      className="rounded-md border bg-muted/40 p-3 text-sm flex flex-col gap-2 text-left"
      data-testid="today-so-far"
    >
      <div className="font-medium">Today so far</div>
      <div className="flex flex-wrap gap-x-6 gap-y-1">
        <span>
          Checked in at <strong>{data.checkinAt ? formatTimeToIST(data.checkinAt) : "—"}</strong>
        </span>
        <span>
          Breaks: <strong>{data.breakCount}</strong>
        </span>
        <span>
          Total break time: <strong>{formatDuration(data.totalBreakSeconds)}</strong>
        </span>
      </div>
      {data.onBreak && (
        <p className="text-amber-700 dark:text-amber-300">
          You are on a break right now. It will end when you check out.
        </p>
      )}
      <div className="max-h-40 overflow-y-auto pr-1">
        <BreakList breaks={data.breaks} emptyText="No breaks today." />
      </div>
    </div>
  );
};
